<template>
  <div class="all">
    <div id="section1" class="project-wrap">
      <div class="content">
        <img :src="detail_data.image_path" alt="" class="img-fluid">
      </div>
      <div class="info">
        <div class="scroll-area">
          <h1 class="project-name">{{detail_data.name}}</h1>
          <h1 class="project-type">{{detail_data.description}}</h1>
          <div class="link-wrap">
            <a :href="detail_data.url" v-if="detail_data.url" class="project-link interview" target="_blank"><img src="/static/images/project/interview.svg" alt="">前往網站</a>
            <div class="project-link back" @click="previous"><img src="/static/images/project/back.svg" alt="">回作品列表</div>
          </div>
          <hr>
          <div class="concept">
            <h1 class="title">CONCEPT.</h1>
            <article class="text-block" v-html="concept"></article>
          </div>
          <hr>
          <div class="credits">
            <h1 class="title">CREDITS.</h1>
            <article class="text-block" v-html="credits"></article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import navigation from './navigation.vue';
  export default {
    name: 'Project-detail',
    components: {
      navigation
    },
    data() {
      return {
        detail_data:[],
        concept:'',
        credits:''
      }
    },
    methods: {
      previous(){
        this.$router.go(-1);
      },
      CallProjectDetailApi(){
        let vm = this;
        vm.axios({
          method: "get",
          url: process.env.VUE_API_URL + "v1/product",
          params:{
            slug: vm.$route.params.id
          }
        })
        .then(function (response) {
          console.log(response)
          let res = response.data.data.trans;
          vm.detail_data = res
          vm.concept = res.editors[0].content;
          vm.credits = res.editors[1].content;
          console.log(vm.detail_data)
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    mounted(){
      this.CallProjectDetailApi();
    }
  }

</script>

<style lang="scss" scoped>
  .project-wrap {
    display: flex;
    width: 100%;
    padding-left: 233px;
    background-color: white;
    @media screen and (max-width: 1400px){
      flex-direction: column-reverse;
      flex-wrap: wrap;
    }
    @media screen and (max-width: 992px){
      padding-left: 0;
    }
    .content {
      width: calc(100% - 445px);
      @media screen and (max-width: 1400px){
        width: 100%;
      }
    }

    .info {
      width: 445px;
      height: 100vh;
      padding: 20px 32px 50px 32px;
      background-color: white;
      box-shadow: -24px 12px 52px 0 rgba(0, 0, 0, 0.16);
      z-index: 0;
      position: sticky;
      top: 0;
      color: black;
      @media screen and (max-width: 1400px){
        width: 100%;
        height: auto;
        position: static;
        box-shadow: none;
      }
      @media screen and (max-width: 992px){
        margin-bottom: 50px;
      }
      .scroll-area{
        padding-top: 78px;
        height: 100%;
        overflow-y: auto;
        @media screen and (max-width: 992px){
          padding-top: 0;
        }
        &::-webkit-scrollbar {
          display: none;
        }
      }
      

      h1.title {
        font-size: 30px;
        font-weight: bold;
        letter-spacing: 1.5px;
        line-height: 1.5;
        margin-top: 0;
        margin-bottom: 16px;
      }

      .project-name,
      .project-type {
        font-size: 30px;
        letter-spacing: 3px;
        padding-left: 15px;
        font-weight: bold;
        @media screen and (max-width: 992px){
          text-align: center;
          padding-left: 58px;
          padding-right: 58px;
        }
        @media screen and (max-width: 576px){
          font-size: 24px;
        }
      }

      .project-name {
        margin-top: 0;
        margin-bottom: 12px;
      }

      .project-type {
        margin-top: 0;
        margin-bottom: 65px;
        @media screen and (max-width: 992px){
          margin-bottom: 20px;
        }
      }

      .link-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;

        .project-link {
          display: flex;
          align-items: center;
          font-size: 23px;
          letter-spacing: 1.2px;
          color: #00a3db;
          @media screen and (max-width: 576px){
            font-size: 16px;
          }
          &.back {
            cursor: pointer;
          }

          img {
            width: 27px;
            height: 27px;
            margin-right: 10px;
            @media screen and (max-width: 576px){
              width: 18px;
              height: 18px;
            }
          }
        }
      }

      hr {
        margin-top: 28px;
        margin-bottom: 28px;
        border-top: 1px solid #707070;
      }

      .concept {
        padding: 0 15px;

        .text-block {
          letter-spacing: 2.4px;
          font-weight: bold;
          text-align: justify;
        }
      }

      .credits {
        padding: 0 15px;

        .text-block {
          letter-spacing: 2.4px;
          font-weight: bold;
          text-align: justify;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ProjectsDetail.vue